import { DealerAdminTabs } from './DealerAdminTabs';
import { useEffect } from 'react';
import { useRouteStore } from '../../Store'

export default function DealerAdminContainer(): JSX.Element {

  const setHideBanner =  useRouteStore((state:any) => state.setHideBanner);

  useEffect(() => {
    const feedbackButton = document.querySelector(".QSIFeedbackButton") as HTMLElement | null;
    if (feedbackButton) {
        feedbackButton.style.display = "none";
    }
    const aiva = document.querySelector(".aiva-unify") as HTMLElement | null;
    if (aiva) {
      aiva.style.display = "none";
    }
    const pullupContainer = document.querySelector("#QSIFeedbackButton-target-container") as HTMLElement | null;
    if (pullupContainer) {
        pullupContainer.style.display = "none"; 
    }

    setHideBanner(true);

     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]); 

  return (
      <DealerAdminTabs></DealerAdminTabs>
  );
}
